<script>
	let { heading = 'default' } = $props();
</script>

{#if heading == 'default'}
	<p>
		Consider the cost and disruption of replacing your windows. A <stong
			>vinyl window averages $66-$87/sf</stong
		>. A <strong>wood window averages $71-$109/sf</strong>. With Indow inserts
		averaging between $31-$44/sf MSRP, your window project can cost a fraction
		of other options.
	</p>
{:else if heading == 'sleep-panel'}
	<p>
		You’ve tried other options that don’t work. Window attachments that have to
		be replaced over and over. Window treatments that only block some drafts,
		noise, or light. Indow inserts are a permanent solution for your windows
		that can still be removed at any time.
	</p>
{/if}
